module.exports = __webpack_public_path__ + "img/sendi-no-disponible-caja.04a3323c.png";